import React, { useState } from "react"
import {
  CustomReasonCode,
  Maybe,
  OrderModificationAddresses
} from "lib/types/generated/graphql-types"

import dayjs from "dayjs"
import { BaseData, Container, Dates, ExpandIcon, NotCompleted } from "./Shared.styled"
import { ReactComponent as DownIcon } from "images/icons/chevron-down.svg"
import { useQuery } from "@apollo/client"
import LoadingRow from "./LoadingRow"
import Reason from "./Reason"
import GET_ADDRESS_MODIFICATION from "../../../graphql/queries/order/GetAddressModification"
import AddressInfo from "../Address/AddressInfo"

type Props = {
  modificationId: string
  getCustomCode: (code: Maybe<string> | undefined) => CustomReasonCode
}
const ModificationOrderAddresses = ({ modificationId, getCustomCode }: Props) => {
  const [expanded, setExpanded] = useState<boolean>(false)

  const { data, loading } = useQuery(GET_ADDRESS_MODIFICATION, {
    variables: { modificationId }
  })

  const modification = data?.Order?.orderModificationAddresses as OrderModificationAddresses
  const modificationAddresses = modification?.addresses ?? []

  if (loading) return <LoadingRow />

  return (
    <Container>
      {!modification?.completed && <NotCompleted>Not completed</NotCompleted>}
      <BaseData onClick={() => setExpanded(!expanded)}>
        <h3>Modification #{modification.id}</h3>
        <Dates>
          <div>
            Started: <b>{dayjs(modification.created).format("YYYY-MM-DD : HH:mm:ss")}</b>
          </div>
          <div>
            Last updated: <b>{dayjs(modification.updated).format("YYYY-MM-DD : HH:mm:ss")}</b>
          </div>
          {modification?.completed && (
            <div>
              Completed: <b>{dayjs(modification?.completed).format("YYYY-MM-DD : HH:mm:ss")}</b>
            </div>
          )}
          {modification?.restarted && (
            <>
              <div>
                Restarted: <b>{dayjs(modification.restarted).format("YYYY-MM-DD : HH:mm:ss")}</b>
              </div>
              <div>
                Restarts: <b>{modification.restarts}</b>
              </div>
            </>
          )}
        </Dates>
      </BaseData>
      {expanded && modificationAddresses.data.billingAddress && (
        <AddressInfo
          address={modificationAddresses?.data?.billingAddress}
          showCustomerInfo={true}
          label={"Updated billing address"}
        />
      )}
      {expanded && modificationAddresses.data.shippingAddress && (
        <AddressInfo
          address={modificationAddresses?.data?.shippingAddress}
          showCustomerInfo={true}
          label={"Updated shipping address"}
        />
      )}
      <Reason getCustomCode={getCustomCode} reason={modification?.reason} />
      <ExpandIcon $expanded={expanded} onClick={() => setExpanded(!expanded)}>
        <DownIcon />
      </ExpandIcon>
    </Container>
  )
}

export default ModificationOrderAddresses
